import { type AdditionalBanner } from "./models";

export const additionalBanners: AdditionalBanner[] = (window as any).odendo
    .globals.additionalBanners;
